/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* istanbul ignore file */
import * as Survey from "survey-react";
import { PersonRequest } from "@plinknz/tah-website-elements";

import { APPLIED_STATUS, BenefitType, GrantPayload } from "../../config/forms";
import { createSVGNew } from "../svg/svg";
import { collapseSurrogate } from "../../service/forms/config-generics/personal-details";

export function transformBenefitFormData(
    survey: Survey.ReactSurveyModel,
    member: PersonRequest,
    benefitType: BenefitType
): GrantPayload {
    const now = new Date().getTime();
    const tenant = process.env.TAH_TENANT;
    const data = collapseSurrogate(survey.data);

    const { svg, text } = createSVGNew({
        heading: `${benefitType} Application`,
        data: {
            ...data,
            member,
        },
    });

    const payloadData: GrantPayload = {
        data: {
            benefit: {
                benefitDescription: benefitType,
                benefitStatus: APPLIED_STATUS,
                benefitDate: now,
            },
            interaction: {
                interaction: svg,
                interactionDate: now,
            },
            email: {
                name: data.name,
                email: data.email,
                message: text,
            },
        },
        targetId: survey.data.applicant || member.id,
        recaptcha: null,
        tenant,
    };

    return payloadData;
}
